import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitAddClients = {
  clients: string[];
};

export const addClients = async (data: SubmitAddClients) => {
  const response = await axios.post<SubmitAddClients>(
    `${rootUrl}/psychologist/add/clients`,
    {
      clients: data.clients,
      token: getCookies('auth'),
    }
  );

  return response.data;
};
